module.exports = __webpack_public_path__ + "static/media/0018.761d34da.jpg";